module.exports = __webpack_public_path__ + "img/260.3ec41a99.svg";